import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import { useSelector, useDispatch } from 'react-redux'
import Sticky from 'react-stickynode'
import {
  selectShowUserFeedsSidebar,
  selectUserSavedSearches,
  selectIsUserLoggedIn,
  selectUserCustomFeeds,
} from '../../selectors/userSelector'
import { selectTrendingTagItems } from '../../selectors/tagsSelector'
import SidebarApps from '../../components/widgets/SidebarApps'
import { BoxAd, AlmaAjoBoxAd, BOX_AD_RIGHT_1, BOX_AD_RIGHT_2, BOX_AD_RIGHT_3, BOX_AD_RIGHT_4 } from '../../ad/Ad'
import { CooperationBannerBox } from '../../ad/CooperationBanner'
import SidebarPopular from '../../components/widgets/SidebarPopular'
import SidebarUserFeed from '../../components/widgets/SidebarUserFeed'
import TrendingTagsBox from '../widgets/TrendingTagsBox'
import { TelkkuColumn } from '@almamedia/alma-embeds/dist/telkku-column'
import { selectLocationPath } from '../../selectors/statusSelector'
import { config } from '../../../config/config'
import '../../styles/sidebar.pcss'
import WidgetBox from '../widgets/WidgetBox'
import SavedSearches from '../widgets/SavedSearches'

/* IMPORTANT:
* When using GeneralSidebar component on a page make sure to include the id='sticky-ad-bottom-boundary'
* property on the pages content div, so that on small height screens the sticky ad does not scroll over the footer
* --Yacine
*/
const GeneralSidebar = ({ category, tag }) => {
  const dispatch = useDispatch()

  const showUserFeedsBox = useSelector((state) =>
    selectShowUserFeedsSidebar(state) && selectUserCustomFeeds(state).size > 0
  )
  const savedSearches = useSelector(selectUserSavedSearches)
  const trendingTags = useSelector(selectTrendingTagItems)
  const trendingFailedToLoad = useSelector((state) => state.trending.get('failedToLoad'))
  const path = useSelector(selectLocationPath)
  const loggedIn = useSelector(selectIsUserLoggedIn)

  return (
    <aside className='sidebar'>

      <TrendingTagsBox
        trending={ trendingTags }
        failedToLoad={ trendingFailedToLoad }
      />

      { path === '/tv' &&
        <CooperationBannerBox
          title='Yhteistyössä Telkku:' path={ path }
        >
          <TelkkuColumn utmSource={ config.siteUrl } />
        </CooperationBannerBox>
      }

      <BoxAd adUnitId={ BOX_AD_RIGHT_1 } />

      <WidgetBox title='Tallennetut haut'>
        <SavedSearches dispatch={ dispatch } savedSearches={ savedSearches } loggedIn={ loggedIn } />
      </WidgetBox>

      <SidebarPopular category={ category } tag={ tag } />

      { !path.startsWith('/saa') &&
        <BoxAd adUnitId={ BOX_AD_RIGHT_2 } />
      }

      { !path.startsWith('/saa') &&
        <CooperationBannerBox title='Alma Ajon kumppani:' path={ path }>
          <AlmaAjoBoxAd adUnitId={ BOX_AD_RIGHT_3 } />
        </CooperationBannerBox>
      }

      { !path.startsWith('/saa') &&
        <BoxAd adUnitId={ BOX_AD_RIGHT_4 } />
      }

      { showUserFeedsBox &&
        <SidebarUserFeed />
      }

      <SidebarApps />

      { !path.startsWith('/saa') && (
        <Sticky top={ 50 } bottomBoundary='#sticky-ad-bottom-boundary'>
          <BoxAd adUnitId='almad-aside-right-7' />
        </Sticky>
      ) }
    </aside>
  )
}

GeneralSidebar.propTypes = exact({
  category: ImmutablePropTypes.record,
  tag: ImmutablePropTypes.record,
})

export default GeneralSidebar
